import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\"><path d=\"M11.4284 5.07129L7.99986 8.49986M7.99986 8.49986L4.57129 5.07129M7.99986 8.49986L4.57129 11.9284M7.99986 8.49986L11.4284 11.9284\" stroke=\"#0476EB\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol